import { createContext } from "react";

export const GDPRStore = createContext({
    gdprEnabled: false,
    tcData: {},
    otherVendors: {},
});